/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_New_Page_TitleInputs */



/**
* | output |
* | --- |
* | "New Tournament" |
*
* @param {Tournament_New_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_new_page_title = /** @type {((inputs?: Tournament_New_Page_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_New_Page_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouveau tournoi")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nuevo torneo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Novo Torneio")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuovo Torneo")
	return /** @type {LocalizedString} */ ("New Tournament")
});